// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"700":"ce4a8673","787":"07ef1cfe","902":"525075d9"}[chunkId] + ".chunk.js";
};